// Server-side: Fetch Google reviews by place_id
// Requires:  key
// Flow: Place Details (reviews)
//
// Conversation summary:
// - Google Places Details is limited to 5 reviews per request.
// - There is no parameter to increase this limit for standard place searches.
// - The Google Business Profile API can return more reviews, but only for
//   businesses that the requesting account owns or manages.
// - Our current implementation uses Places Details, so it may return fewer
//   reviews than the business profile total.
import { smartFetch } from '../foundation/smartfetch';
import { buildUrl } from '../foundation/urlbuilder';
export async function getGoogleReviewsByPlaceId(params) {
    const { placeId, language, maxReviews, proxyBase, apiKey } = params;
    const queryParams = {
        place_id: placeId,
        fields: 'reviews,name,place_id,formatted_address',
        key: apiKey
    };
    if (language) {
        queryParams.language = language;
    }
    const detailsUrl = buildUrl({
        baseUrl: 'https://maps.googleapis.com',
        pathSegments: ['maps', 'api', 'place', 'details', 'json'],
        params: queryParams,
        proxyUrl: proxyBase || undefined,
    });
    const detData = await smartFetch(detailsUrl, {
        proxy: proxyBase ? { url: proxyBase, fallbackOnCors: true } : undefined,
    });
    if (detData.status !== 'OK' || !detData.result) {
        return { reviews: [] };
    }
    const place = {
        name: detData.result.name,
        place_id: detData.result.place_id,
        formatted_address: detData.result.formatted_address,
    };
    const reviews = Array.isArray(detData.result.reviews) ? detData.result.reviews : [];
    const limited = typeof maxReviews === 'number' ? reviews.slice(0, maxReviews) : reviews;
    return { place, reviews: limited };
}
